import { render } from "./GroupMaster.vue?vue&type=template&id=cf79d294&scoped=true"
import script from "./GroupMaster.vue?vue&type=script&lang=js"
export * from "./GroupMaster.vue?vue&type=script&lang=js"

import "./GroupMaster.vue?vue&type=style&index=0&id=cf79d294&scoped=true&lang=css"

import exportComponent from "/home/projects/frontend.vendor-mailing-system.pravin/vendor-mailig-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf79d294"]])

export default __exports__